module.exports = __webpack_public_path__ + "static/project-1a-d1506525f9e127caa6eba68823126fdc.png";